import './assets/main.css'

import {
  createApp
} from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import 'ant-design-vue/dist/reset.css'
import * as Icons from '@ant-design/icons-vue'
import './assets/iconfont/iconfont.css'
import './permission'
import router from './router/index'
import store from './store'
import {
  actions
} from './globalState'
import {
  i18n
} from '@/i18n'
import buttonGroup from '@/components/button-group/index.vue'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'

// 字典标签组件
import DictText from '../src/components/DictText/index.vue'

const app = createApp(App)

app.config.globalProperties.$antdIcons = Icons

app.use(router)
app.use(store)
app.use(i18n)
app.use(Antd)
app.use(VXETable)
app.use(VxeUI)

// 监听子应用传递，从其他位置也可以监听
actions.setGlobalState({
  ...store.state.share
})
actions.onGlobalStateChange((state) => {
  const currentStateString = JSON.stringify(store.state.share)
  const nextStateString = JSON.stringify(state)
  if (currentStateString !== nextStateString) {
    // 与当前state不一致的话，需要更新
    store.dispatch('share/updateShareInfo', state)
  }
})

app.mount('#app')
app.component('buttonGroup', buttonGroup)
app.component('dict-text', DictText)

for (const i in Icons) {
  app.component(i, Icons[i])
}


import {
  getDict
} from '@/utils/dict'
app.provide('dict', getDict)